import { toast } from 'react-toastify';
import jwtDecode from 'jwt-decode';
import axios from "axios";
import localdomain from "../../utils/constant.js";
import api from "../../utils/axios-util.js";

console.log("actionnnnnnnn");
const auth0Config = localdomain();
const common_api_url = auth0Config.common_api_url;
console.log("common_api_urlcommon_api_url",common_api_url);

export const login = (username, password) => {
  return (dispatch) => {
   
    return new Promise((resolve, reject) => {
      fetch(`${common_api_url}/v2/oauth/login`, {
      
       method: 'POST',
        body: JSON.stringify({ username, password }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status === 200) {
             
            return response.json();

          } else {
            reject('Login failed. Please check your credentials.');
          }
        })
        .then((data) => {
          // Additional data to be returned along with the resolved promise
          console.log("dataaaaaaaaaaaaaaaa",data);
          const additionalData = {
            token: data.access_token,
            status:data.statusCode
          };

          const access_token = data.access_token;
          const decoded = jwtDecode(access_token);
          let apinfo = {
            access_token: access_token,
            tenant_code: `${decoded['http://api.doocti.com/claims/tenant_code']}`,
            api_url: `https://${decoded['http://api.doocti.com/claims/api_domain']}`,
            dialer_url: `https://${decoded['http://api.doocti.com/claims/dialer_domain']}`,
            portal_url: `https://${decoded['http://api.doocti.com/claims/portal_domain']}`,
            token: data.access_token,
            socket_url: `https://${decoded[`http://api.doocti.com/claims/socket_domain`]}`,
            AuthUser: `${decoded[`aud`][1]}`,
          };
          console.log("apinfoooooooooooo",apinfo.dialer_url);
             api.defaults.baseURL = apinfo.dialer_url;
            //  api.defaults.baseURL = 'http://localhost:3001';
          
            localStorage.setItem('apinfo', JSON.stringify(apinfo));
          localStorage.setItem('token', JSON.stringify(data));
          // localStorage.setItem('login', true);
         
          resolve(additionalData); // Resolve the Promise with additional data
        })
        .catch((error) => {
          console.error('Login error:', error);
          toast.success('Login Failed', {
            position: toast.POSITION.TOP_CENTER, // Set toast position
          
          });
         
          reject(error); // Reject the Promise to indicate a login error
        });
    });
  };
};
 

export const AsterConfig = (username,doocti_tenent) => {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        // const apiToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiJhdGxhbnRvc29mdCIsInVzZXJuYW1lIjoiYXRsYW50b3NvZnRfYWRtaW4iLCJzY29wZSI6ImFkbWluIiwiaXNzIjoiaHR0cHM6Ly9saXZlLWRvb2N0aS5hdS5hdXRoMC5jb20vIiwic3ViIjoiejZMMzlyekRhZmtub0tucjVWUHloMU8zRW9aVUxGUGRAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vcHJvZC1hcGkuZG9vY3RpLmNvbSIsImV4cCI6MTY2ODg3Mzk2ODk3MiwiaWF0IjoxNjA1ODAxOTY4fQ.f_TV2TheSK7ikg92MM91h6QN29BlUvxvMivr9fZcFKk";
        const apiToken = localStorage.getItem('apinfo'); 
        const apitoken = JSON.parse(apiToken);
         const configaccesstoken =apitoken.token;
       
        const headers = {
          Authorization: `Bearer ${configaccesstoken}`, // Add the bearer token here
        };
       
        await api
          .get(`${common_api_url}/common/project/config?tenant_code=${doocti_tenent}&user_email=${username}`,{ headers })
          .then((response) => {
            resolve(response);

          })
          .catch((err) => {
            console.log("configapierrorin actionpage:");
            reject(err);
          });
      });
    };
  };  

  export const LoginUserinfo = (payload) => {
    return (dispatch, getState) => {
      console.log("LoginPayload:",payload.queue)
      return new Promise(async (resolve, reject) => {
        await api.post(`/crm/login`, payload)
          .then((response) => {
            if (response.status === 200) {
              // window.location.href = `/callpopup`;
             window.location.href='/callpopup'; 
              localStorage.setItem('login', true);
               toast.success('Login successful!', {
                position: toast.POSITION.TOP_CENTER, // Set toast position
              
              });
            }
            resolve(response);
          })
          .catch((err) => {
            console.log("errerr",err.response.data.statusCode);
            if (err.response.data.statusCode == 409) {
              toast.success('User Already Exist', {
                position: toast.POSITION.TOP_CENTER, // Set toast position
                           
              });
            }
            else{
              toast.success('Login Failed', {
                position: toast.POSITION.TOP_CENTER, // Set toast position
              
              }); 
            }
                        
            
          });
      });
    };
  };

 
  export const Hangup = (payload) => {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        
       
        await api
        .post(`/api/crm/dispose`,payload)
          .then((response) => {
            console.log("responseresponse122",response);
            resolve(response);

          })
          .catch((err) => {
            reject(err);
          });
      });
    };
  }; 
  
  export const Resume =(payload) =>
  {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        console.log("payloaddddddddd",payload);
        
        const apiToken = localStorage.getItem('apinfo'); 
        const apitoken = JSON.parse(apiToken);
         const configaccesstoken =apitoken.token;
       
        const headers = {
          Authorization: `Bearer ${configaccesstoken}`, // Add the bearer token here
        };
       console.log("headersheaders",headers);

        await api 
          .post(`/api/v2/resume`,payload, { headers })
          .then((response) => {
           console.log("responseresponseresume",response);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

  }

  export const Pause =(payload) =>
  {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        console.log("payloaddddddddd",payload);
        
        const apiToken = localStorage.getItem('apinfo'); 
        const apitoken = JSON.parse(apiToken);
         const configaccesstoken =apitoken.token;
       
        const headers = {
          Authorization: `Bearer ${configaccesstoken}`, // Add the bearer token here
        };
       console.log("headersheaders",headers);

        await api 
          .post(`/api/v2/pause`,payload, { headers })
          .then((response) => {
           console.log("responseresponseresume",response);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

  }

  export const Logout =(payload) =>{
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        console.log("LogoutPayload:",payload);
      
       
        
        await api 
          .post(`/crm/logout`,payload )
          .then((response) => {
           console.log("responseresponseresume",response.status);
            if (response.status == 200) {
              localStorage.removeItem('login');
              localStorage.removeItem('hanguppayload');
              localStorage.removeItem('resume');
              localStorage.removeItem('agentstatus');
              localStorage.removeItem('config');
              localStorage.removeItem('username');
              localStorage.removeItem('apinfo');
              localStorage.removeItem('token');  
              localStorage.removeItem('callstatus');
              localStorage.removeItem('queuelogin');
               localStorage.removeItem('crmuserinfo');
              localStorage.removeItem('entititytype');
              localStorage.removeItem('station');
              console.log("kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk",localStorage.getItem('pagestatus'));
                                
                                        
              window.location.href = `/`;
               
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };
  }
  
  export const FetchDispo =()=>{
    return () => {
      return new Promise(async (resolve, reject) => {
        
        await api
          .get(`/disposition?active=Y`)
          .then((response) => {
            console.log("Dispo Response=========>");
            resolve(response);

          })
          .catch((err) => {
            console.log("Dispoerrorin actionpage:");
            reject(err);
          });
      });
    };
  }
 
  
  
  
  
  